import { Component, OnInit, Input } from '@angular/core';
/* import { latLng, MapOptions, tileLayer, Map, Marker, icon, LeafletMouseEvent } from 'leaflet';*/
import { MapService } from 'src/app/services/map.service';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit {
  @Input() address: any={};
  @Input() lat: any = null;
  @Input() lng: any = null;
  @Input() zoom: number = 11;

  /* map: Map; */
  map: any;
  /*mapOptions: MapOptions;*/

  agmIcon: any = {
	url: './assets/icons/marker-icon.png',
	scaledSize: {
		width: 32,
		height: 40
	}
}
  constructor(
    public mapService: MapService
  ) { }

  ngOnInit(): void {
    this.initializeMapOptions();
  }

  ngOnChanges() {
	this.setMarker(this.lat, this.lng);
	/* this.map.setCenter({ lat: parseFloat(this.lat), lng: parseFloat(this.lng) }) */
	
  }

  onMapReady(map) {
		/* if(this.map) {
			this.map.remove()
		} else {
			this.map = map;
			/* this.addSampleMarker();
			this.map.on('click', <LeafletMouseEvent>( e ) => {
				this.setMarker(e.latlng.lat, e.latlng.lng);
			});

		} */
		this.map = map;
		this.map.setZoom(15);
  }
  
  theMarker: any;
	private initializeMapOptions() {
		/*this.mapOptions = {
		  center: latLng(14.6091, 121.0223),
		  zoom: 11,
		  layers: [
			tileLayer(
			  'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
			  {
				maxZoom: 18,
			  })
		  ],
		};*/
  }
  
  private setMarker(lat, lng) {
	  this.mapService.coords.lat = lat;
	  this.mapService.coords.lng = lng;
		/* const marker = new Marker([lat, lng])
		  .setIcon(
			icon({
			  iconSize: [30, 40],
			  iconAnchor: [13, 41],
			  iconUrl: 'assets/icons/marker-icon.png'
			}));
			if (this.theMarker != undefined) {
				this.map.removeLayer(this.theMarker);
		  }; */
  
	  	//Add a marker to show where you clicked.
	  /*  this.theMarker = marker.addTo(this.map); */
	   
	}

	timeoutHandler: any;
	dragtime = 0;
	public mouseup() {
		if(this.timeoutHandler) {
			clearInterval(this.timeoutHandler);
			this.dragtime = 0;
			this.timeoutHandler=null;
		}
	}
	  
	public mousedown() {
		this.timeoutHandler = setInterval(() => {
			this.dragtime +=1;
		}, 50) ;
	}

	markerDragEnd(lat, lng, $event) {
		/* this.defaultCoords.lat = $event.coords.lat;
		this.defaultCoords.lng = $event.coords.lng; */
		this.mapService.coords.lat = $event.coords.lat;
	  	this.mapService.coords.lng = $event.coords.lng;
		/* const geocoder = new google.maps.Geocoder();
		const latlng = new google.maps.LatLng(this.latitude, this.longitude); */
		// this.setShippingCoords();
	}
}
